"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonConstants = void 0;
exports.CommonConstants = Object.freeze({
    Bytes32StrLen: 66,
    CodeHashEmpty: "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
    StorageHashEmpty: "0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421",
});
